import { render, staticRenderFns } from "./carouselitem.vue?vue&type=template&id=e04dd4bc&scoped=true&"
import script from "./carouselitem.vue?vue&type=script&lang=js&"
export * from "./carouselitem.vue?vue&type=script&lang=js&"
import style0 from "./carouselitem.vue?vue&type=style&index=0&id=e04dd4bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04dd4bc",
  null
  
)

export default component.exports